// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"682":"86108a58","787":"0c3ad02f"}[chunkId] + ".chunk.js";
};